import { getUserPreset } from 'common/api/v1/users';

import {
    FETCH_PRESET,
    FETCH_PRESET_FAILURE,
    FETCH_PRESET_SUCCESS,
} from '../actionTypes';
import { panelLayoutV2Actions } from '../reducer';

export default (id) => (dispatch) => {
    dispatch(panelLayoutV2Actions[FETCH_PRESET]());

    getUserPreset(id)
        .then((response) => {
            dispatch(
                panelLayoutV2Actions[FETCH_PRESET_SUCCESS](response.data.data),
            );
        })
        .catch((error) => {
            dispatch(
                panelLayoutV2Actions[FETCH_PRESET_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
        });
};
